﻿import axios from 'axios';

const websiteApiBaseUrl = (import.meta.env.VITE_WEBSITE_API_BASE_URL || 'https://api.beautysports.in/website-api').replace(/\/$/, '');

export interface WebsitePolicy {
  id?: string;
  uuid?: string;
  type?: string;
  title: string;
  description: string;
  updatedAt?: string;
}

export type WebsitePolicyType = 'terms' | 'privacy' | 'about';

export async function getWebsitePolicy(type: WebsitePolicyType): Promise<WebsitePolicy | null> {
  try {
    const response = await axios.get<{ data: WebsitePolicy }>(websiteApiBaseUrl + '/policies/' + type);
    return response.data.data || null;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) return null;
    throw error;
  }
}

